<!-- Contacts model -->
<div class="modal-header">
    <h5 class="modal-title">Ajouter un article</h5>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-3">
    <div class="text-left">
        <form>
            <!-- Première ligne -->
            <div class="row mb-3">
                <div class="form-group col-md-6">
                    <label for="code">Titre</label>
                    <input [(ngModel)]="item.titre" name="code" type="text" class="form-control" id="code">
                </div>
                <div class="form-group col-md-6">
                    <label for="libelle">Description</label>
                    <input [(ngModel)]="item.description" name="libelle" type="text" class="form-control" id="libelle">
                </div>

            </div>

        

            <!-- Troisième ligne -->
            <div class="row mb-3">
                <div class="form-group col-md-6">
                    <label>Photo</label>
                    <input (change)="onFileSelected($event)" name="photo" type="file" class="form-control"
                        placeholder="Photo " />
                </div>

            </div>


            <div class="text-end mt-3">
                <button (click)="close()" type="button" class="btn btn-light ms-1">
                    <i class="pi pi-times" style="color: #212529"></i> Annuler
                </button>&nbsp;
                <button (click)="updateSlideArticle()" type="submit" class="btn btn-success">
                    <i class="pi pi-save" style="color: white"></i> Enregistrer
                </button>
            </div>

        </form>
    </div>
</div>